import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { routes } from "schemas/routes";

interface IProps {
  open: boolean;
  handleClose: () => void;
  searchQuery: string;
}

export default function CompletedDialog({
  open,
  handleClose,
  searchQuery,
}: IProps) {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h4">Pitch to Local Brands</Typography>
      </DialogTitle>
      <DialogContent sx={{ mt: 1 }}>
        <Typography paragraph>
          You've successfully created a collection of local brands to pitch to
          based on your search: <strong>{searchQuery}</strong>
        </Typography>
        <Typography paragraph>
          We're now finding contacts for the brands you selected. You'll{" "}
          <strong>receive an email</strong> once everything is processed. That
          email will include a link to a newly created campaign on your{" "}
          <Link
            component={RouterLink}
            to={`/${routes.campaignView}`}
            underline="hover"
          >
            campaigns page
          </Link>
          —just click <strong>"Send"</strong> and we'll schedule the emails for
          you.
        </Typography>

        <Typography paragraph>
          Ready to pitch to more brands? Close this dialog and start a new
          search whenever you're ready.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
